import { FeatureType, userService } from '@/services/userService'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import styles from './UpgradeLinkBtn.module.less'

export const UpgradeLinkBtn = observer(
  ({
    version,
    text,
    source,
    feature,
    styleCSS,
  }: {
    version: 'max' | 'ultra'
    text: string
    feature: FeatureType
    source: string
    styleCSS?: React.CSSProperties
  }) => {
    return (
      <div
        className={classNames(styles.upgradeLinkBtn, styles[version])}
        style={styleCSS}
        onClick={() => {
          userService.doPay({
            from: source,
            version,
            feature,
          })
        }}
      >
        {text}
      </div>
    )
  }
)
